//
// メインスライダー。
//
(function(slider)
{
	console.log(slider);
	if (!slider) return;
	new Swiper (slider, {
		loop: true,
		speed: 1000,
		slidesPerView: 1.2,
		centeredSlides: true,
		autoplay: {
			delay: 3000,
		},

		preloadImages: false,
		lazy: {
			loadOnTransitionStart: true,
			loadPrevNextAmount: 1,
		},
		breakpoints: {
			560: {
				slidesPerView: 1.5,
			}
		},
		pagination: {
			el: '.p-main-slider__pagination',
			clickable: true,
		},

		navigation: {
			nextEl: '.p-main-slider__next',
			prevEl: '.p-main-slider__prev',
		}
	});
})(document.querySelector('.js-main-slider'));
//
// 特集スライダー。
//
(function(slider)
{
	if (!slider) return;
	new Swiper (slider, {
		loop: true,
		speed: 1000,
		autoplay: {
			delay: 3000,
		},

		preloadImages: false,
		lazy: {
			loadOnTransitionStart: true,
			loadPrevNextAmount: 1,
		},

		navigation: {
			nextEl: '.p-feature-slider__next',
			prevEl: '.p-feature-slider__prev',
		}
	});
})(document.querySelector('.js-feature-slider'));
//
// おすすめスライダー。
//
(function(sliders)
{
	for (var i = 0; i < sliders.length; i++) {
		let slider = sliders[i];
		let prev = slider.parentNode.querySelector('.swiper-button-prev');
		let next = slider.parentNode.querySelector('.swiper-button-next');
		let opts = {
			// loop: true,
			slidesPerView: 1.2,
			centeredSlides: true,
			spaceBetween: 10,
			speed: 1000,
			autoplay: {
				delay: 3000,
			},

			preloadImages: false,
			lazy: {
				loadOnTransitionStart: true,
				loadPrevNextAmount: 1,
			},
			breakpoints: {
				560: {
					centeredSlides: false,
					slidesPerView: 4,
					spaceBetween: 20,
					slidesPerGroup: 4,
				}
			}
		};
		if (prev && next) {
			opts.navigation = {
				nextEl: next,
				prevEl: prev
			}
		}
		new Swiper(slider, opts);
	}
})(document.querySelectorAll('.js-rec-slider'));
//
// ネイルデザイン用スライダー。
//
(function(slider)
{
	if (!slider) return;
	new Swiper (slider, {
		speed: 1000,
		autoplay: {
			delay: 3000,
		},

		preloadImages: false,
		lazy: {
			loadOnTransitionStart: true,
			loadPrevNextAmount: 1,
		},
		pagination: {
			el: '.p-nailpost__pagination',
			clickable: true,
		},
	});
})(document.querySelector('.js-nailpost-slider'));
//
// メインスライダー。
//
(function(slider)
{
	console.log(slider);
	if (!slider) return;
	new Swiper (slider, {
		loop: true,
		speed: 1000,
		slidesPerView: 1,
		breakpoints: {
			560: {
				slidesPerView: 3,
				spaceBetween: 32,
			}
		},
		navigation: {
			nextEl: '.mainnext',
			prevEl: '.mainprev',
		}
	});
})(document.querySelector('.mainSwiper'));
//
// 特集ページ用スライダー。
//
(function(slider)
{
	if (!slider) return;
	new Swiper (slider, {
		speed: 1000,
		slidesPerView: 1,
		preloadImages: false,
		lazy: {
			loadOnTransitionStart: true,
			loadPrevNextAmount: 1,
		},
		navigation: {
            nextEl: ".featureNext",
            prevEl: ".featurePrev",
		},
	});
})(document.querySelector('.featureSwiper'));
//
// ライトボックス。
//
(function(items)
{
	for (var i = 0; i < items.length; i++) {
		(function(idx)
		{
			const lightbox = items[idx].parentNode.querySelector('.c-lightbox');
			if (lightbox) {
				const lightboxMask = lightbox.querySelector('.c-lightbox__mask');
				if (lightboxMask) {
					lightboxMask.addEventListener('click', function() {
						lightbox.classList.remove('is-active');
					});
				}
				console.log(lightbox);
				items[idx].addEventListener('click', function() {
					console.log(lightbox);
					lightbox.classList.add('is-active');
				});
			}
		})(i);
	}
})(document.querySelectorAll('.js-lightbox'));